import { formatAction } from '../PartnerAuditLogs.utils';
export const auditLogsActionTypes = Object.freeze(['promotion_created', 'promotion_updated', 'promotion_ended', 'promotion_details_viewed', 'promotion_code_created', 'promotion_code_deleted', 'promotion_code_details_viewed']);
export const actionOptions = Object.freeze([{
  label: 'All Actions',
  value: ''
}, ...auditLogsActionTypes.map(type => {
  type = "audit_log_".concat(type);
  return {
    label: formatAction(type),
    value: type
  };
})]);
export const AUDIT_LOGS_NO_RESULT_TITLE = 'No audit logs to show';
export const AUDIT_LOGS_NO_RESULT_SUBTITLE = 'Try searching with a different filter.';